import { render, staticRenderFns } from "./CachePolicies.vue?vue&type=template&id=696e34d9&"
import script from "./CachePolicies.vue?vue&type=script&lang=js&"
export * from "./CachePolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports